export enum DeleteEventOption {
  DeleteSingleEvent = 'Deletesingleevent',
  DeleteFutureEvent = 'Deletefutureevent',
  DeleteWholeSeries = 'Deletethewholeseries',
}
